import React from 'react'
import Rater from 'react-rater'
import { Wrapper } from './components/Styled'

interface Props {
  ratingCount?: number
  isInteractive?: boolean
  onRate?: (rate: any) => void
  ratingPercentage?: number
  reviewsCount?: number
}

export const RatingStars = ({
  ratingCount,
  isInteractive = false,
  onRate,
  ratingPercentage,
  reviewsCount
}: Props) => {
  const StarsTotal = 5
  const averageRating = ratingPercentage && ratingPercentage * StarsTotal / 100
  const rating = ratingCount ?? averageRating
  return (
    <Wrapper>
      <Rater total={StarsTotal} rating={rating} interactive={isInteractive} onRate={onRate} />
      <span>{`(${reviewsCount ?? 0})`}</span>
    </Wrapper>
  )
}
